<div class="flex flex-col h-full gap-3 p-3 overflow-hidden">
    <div class="flex flex-row justify-between">
        <div class="flex flex-row gap-2 items-center">
            @if(isAdmin && (tab == "users" || tab == "invites")){
            <app-menu #addPeopleMenu [items]="addPeopleMenuItems" (itemSelected)="onMenuItemSelected($event)">
                <app-button variant="filled" severity="primary" (clicked)="onAddPeopleClick($event, addPeopleMenu)"
                    label="Add People" [icon]="'plus'" [iconSource]="'lucide'" iconPosition="left" type="button" />
            </app-menu> }
            <app-search-bar
                [placeholder]="tab === 'users' ? 'Search Users' : tab === 'invites' ? 'Search Invites' : 'Search Requests'"
                [(ngModel)]="searchValue" (search)="onSearch()">
            </app-search-bar>
        </div>
        @if(tab === 'requests') {
        <app-select-button [options]="requestViewOptions" [ngModel]="requestView"
            (ngModelChange)="onRequestViewChange($event)" [variant]="'default'">
        </app-select-button>
        }
    </div>
    <div class="flex-1 min-h-0 flex flex-col">
        @if(tab == 'users'){
        <!-- Bulk Action Bar (users) -->
        @if(selectedUsers.length > 0 && hasBillingAccess) {
        <div
            class="flex flex-col sm:flex-row gap-2 p-2 border rounded-base shadow-sm justify-between items-start sm:items-center flex-shrink-0 mb-2">
            <div class="flex items-center gap-2">
                <span class="text-sm font-medium text-gray-700">{{ selectedUsers.length }} {{ selectedUsers.length ===
                    1 ? 'item' : 'items' }} selected</span>
                <div class="hidden sm:block h-5 w-px bg-gray-300"></div>
                <app-button variant="outlined" severity="primary" icon="credit-card" [iconSource]="'lucide'" size="sm"
                    [disabled]="isTrail() && !isSalesPaymentMode"
                    [label]="isSalesPaymentMode ? 'Talk to sales' : 'Change Plan'" (clicked)="openBulkChangePlan()" />
            </div>
        </div>
        }
        <!-- Users Data Table -->
        <app-grid-list-view #usersTable [items]="users" [viewMode]="'list'" [useDataTable]="true"
            [tableColumns]="usersTableColumns" [tableConfig]="usersTableConfig" [dataKey]="'_id'"
            [customTemplates]="templatesMap" [totalRecords]="users.length" [rows]="10"
            [rowsPerPageOptions]="[10, 20, 50]" [showPaginator]="false" [scrollable]="true"
            [parentClass]="'flex-1 flex flex-col min-h-0'" [itemsLoading]="usersTableConfig.loading || false"
            [(selectedItems)]="selectedUsers">
        </app-grid-list-view>
        }@else if(tab == 'invites'){
        <!-- Invites Data Table -->
        <app-grid-list-view #invitesTable [items]="invites" [viewMode]="'list'" [useDataTable]="true"
            [tableColumns]="invitesTableColumns" [tableConfig]="invitesTableConfig" [dataKey]="'_id'"
            [customTemplates]="templatesMap" [totalRecords]="invites.length" [rows]="10" [showPaginator]="false"
            [scrollable]="true" [parentClass]="'flex-1 flex flex-col min-h-0'"
            [itemsLoading]="invitesTableConfig.loading || false">
        </app-grid-list-view>
        }
        @else if (tab == 'requests'){
        <!-- Bulk Action Bar (CURRENT view only) -->
        @if(requestView === REQUEST_VIEW.CURRENT && selectedRequests.length > 0 && hasBillingAccess) {
        <div
            class="flex flex-col sm:flex-row gap-2 p-2 border rounded-base shadow-sm justify-between items-start sm:items-center flex-shrink-0 mb-2">
            <div class="flex items-center gap-2">
                <span class="text-sm font-medium text-gray-700">{{ selectedRequests.length }} {{ selectedRequests.length
                    === 1 ? 'item' : 'items' }} selected</span>
                <div class="hidden sm:block h-5 w-px bg-gray-300"></div>
                @if(getSelectedRejectCreationRequests().length > 0) {
                <app-button variant="outlined" severity="danger" icon="x" [iconSource]="'lucide'" size="sm"
                    [label]="'Reject creation (' + getSelectedRejectCreationRequests().length + ')'"
                    (clicked)="openBulkRejectCreationDialog()" />
                }
                @if(getSelectedApproveCreationRequests().length > 0) {
                <app-button variant="outlined" severity="success" icon="check" [iconSource]="'lucide'" size="sm"
                    [label]="'Approve creation (' + getSelectedApproveCreationRequests().length + ')'"
                    (clicked)="openBulkApproveCreationDialog()" />
                }
                @if(getSelectedRejectDeactivationRequests().length > 0) {
                <app-button variant="outlined" severity="danger" icon="x" [iconSource]="'lucide'" size="sm"
                    [label]="'Reject deactivation (' + getSelectedRejectDeactivationRequests().length + ')'"
                    (clicked)="openBulkRejectDeactivationDialog()" />
                }
                @if(getSelectedApproveDeactivationRequests().length > 0) {
                <app-button variant="outlined" severity="success" icon="check" [iconSource]="'lucide'" size="sm"
                    [label]="'Approve deactivation (' + getSelectedApproveDeactivationRequests().length + ')'"
                    (clicked)="openBulkApproveDeactivationDialog()" />
                }
                @if(getSelectedCreditRequests().length > 0) {
                <app-button variant="outlined" severity="danger" icon="x" [iconSource]="'lucide'" size="sm"
                    [label]="'Reject (' + getSelectedCreditRequests().length + ')'"
                    (clicked)="openBulkRejectCreditDialog()" />
                <app-button variant="outlined" severity="success" icon="check" [iconSource]="'lucide'" size="sm"
                    [label]="'Accept (' + getSelectedCreditRequests().length + ')'"
                    (clicked)="openBulkApproveCreditDialog()" />
                }
            </div>
        </div>
        }
        <!-- Requests Table (shared for both CURRENT and HISTORY view) -->
        <app-grid-list-view #requestsTable [items]="activeRequests" [viewMode]="'list'" [useDataTable]="true"
            [tableColumns]="requestsTableColumns" [tableConfig]="requestsTableConfig" [dataKey]="'_id'"
            [customTemplates]="templatesMap" [totalRecords]="activeRequests.length" [rows]="10" [showPaginator]="false"
            [scrollable]="true" [parentClass]="'flex-1 flex flex-col min-h-0'"
            [itemsLoading]="requestsTableConfig.loading || false" [(selectedItems)]="selectedRequests"
            [rowClass]="requestView === REQUEST_VIEW.CURRENT ? getRequestsRowClass : ''">
        </app-grid-list-view>
        }
    </div>
</div>

<app-dialog [(visible)]="inviteDialogVisible" title="Send Invite" (closed)="onInviteDialogClosed()"
    class="max-w-[55vw] h-[70vh]" [fullscreenOnMobile]="true">
    <ng-template #bodyTemplate>
        <div class="flex flex-col gap-4 p-4 h-full">
            <div class="flex gap-2">
                <div class="flex-1">
                    <input id="name" placeholder="Enter email" autocomplete="off"
                        class="w-full border border-gray-300 rounded-base px-3 py-2 text-sm focus:outline-none focus:border-orange-500"
                        [(ngModel)]="email" />
                </div>
                <app-button variant="filled" severity="primary" label="Add" icon="plus" [iconSource]="'lucide'"
                    [disabled]="!validateEmail() || !canAddMoreMembers()" (clicked)="addMember()" />
            </div>
            <div class="flex-1 overflow-y-auto">
                @for(member of members;track member){
                <div class="flex justify-between items-center my-2">
                    <div class="flex flex-1 items-center min-w-0 gap-2">
                        <app-user-name-display [user]="member" variant="avatar"></app-user-name-display>
                        <span class="truncate max-w-[10rem] text-sm" [pTooltip]="member.email" tooltipPosition="top">{{
                            member.email }}</span>
                    </div>
                    <div class="flex items-center gap-2">
                        <div class="flex items-center justify-end gap-2">
                            <app-button variant="outlined" severity="contrast"
                                [label]="member.planName || orgDefaultPlanName" icon="chevron-right"
                                iconPosition="right" [iconSource]="'lucide'" (clicked)="openPlanForMember($index)"
                                [disabled]="isSalesPaymentMode || isTrail()" />
                            <app-select [(value)]="member.role" [options]="roleOptions" [config]="roleConfig">
                            </app-select>
                        </div>
                        <app-button variant="outlined" severity="danger" icon="trash-2" [iconSource]="'lucide'"
                            (clicked)="removeMember($index)" />
                    </div>
                </div>
                }
            </div>
        </div>
    </ng-template>
    <ng-template #footerTemplate>
        <div class="flex flex-row justify-end w-full">
            <app-button variant="filled" severity="primary"
                [label]="isTrail() ? 'Invite' : hasBillingAccess ? 'Review and Invite' : 'Request Invite'" icon="send"
                [iconSource]="'lucide'" (clicked)="isTrail() ? sendMail() : openBulkInviteCheckout()"
                [disabled]="!members.length || (getRemainingInviteSlots() !== null && members.length > getRemainingInviteSlots()!)"
                type="button" />
        </div>
    </ng-template>
</app-dialog>

@if(deleteUserDialogVisible){
<app-delete-confirmation [(visible)]="deleteUserDialogVisible" headerText="Are you sure?"
    bodyText="Do you want to delete this user?" confirmButtonText="Proceed" (onConfirm)="confirmDeleteUser()">
</app-delete-confirmation>
}

@if(deleteInviteDialogVisible) {
<app-delete-confirmation [(visible)]="deleteInviteDialogVisible" headerText="Are you sure?"
    bodyText="Do you want to revoke the invitation?" confirmButtonText="Proceed" (onConfirm)="confirmDeleteInvite()">
</app-delete-confirmation>
}

@if(approveRequestDialogVisible) {
<app-delete-confirmation [(visible)]="approveRequestDialogVisible"
    [headerText]="selectedRequest?.requestType === REQUEST_TYPE.CREATION ? 'Approve user creation' : selectedRequest?.requestType === REQUEST_TYPE.PLAN_CHANGE ? 'Approve plan change' : 'Approve deactivation'"
    [bodyText]="selectedRequest?.requestType === REQUEST_TYPE.CREATION ? 'Do you want to approve this user creation request?' : selectedRequest?.requestType === REQUEST_TYPE.PLAN_CHANGE ? 'Do you want to approve this plan change request?' : 'Do you want to approve this deactivation request?'"
    confirmButtonText="Proceed" (onConfirm)="confirmApproveRequest()">
</app-delete-confirmation>
}

<!-- Reject Request Confirmation -->
@if(rejectRequestDialogVisible) {
<app-delete-confirmation [(visible)]="rejectRequestDialogVisible"
    [headerText]="selectedRequest?.requestType === REQUEST_TYPE.CREATION ? 'Reject user creation' : selectedRequest?.requestType === REQUEST_TYPE.PLAN_CHANGE ? 'Reject plan change' : 'Reject deactivation'"
    [bodyText]="selectedRequest?.requestType === REQUEST_TYPE.CREATION ? 'Do you want to reject this user creation request?' : selectedRequest?.requestType === REQUEST_TYPE.PLAN_CHANGE ? 'Do you want to reject this plan change request?' : 'Do you want to reject this deactivation request?'"
    confirmButtonText="Proceed" (onConfirm)="confirmRejectRequest()">
</app-delete-confirmation>
}

<!-- Transfer Billing Admin Dialog -->
<app-dialog [(visible)]="transferBillingAdminDialogVisible" title="Transfer Billing Admin"
    description="This user is the billing admin. Please transfer this role to another user before deleting."
    class="max-w-lg" [closable]="false" [showCloseButton]="false">
    <ng-template #bodyTemplate>
        <div class="flex flex-col gap-4 p-1">
            <input type="text" [(ngModel)]="billingAdminTransferSearchQuery" (input)="onBillingAdminTransferSearch()"
                placeholder="Search by name or email"
                class="w-full px-3 py-2 border rounded-lg text-sm focus:outline-none focus:border-orange-500" />
            <div class="flex flex-col gap-1 max-h-64 overflow-y-auto">
                @for(user of billingAdminTransferFilteredUsers; track user._id){
                <div class="flex items-center gap-3 p-2 rounded-lg cursor-pointer hover:bg-gray-50 border"
                    [class.border-orange-500]="selectedBillingAdminTransferUser?._id === user._id"
                    [class.bg-orange-50]="selectedBillingAdminTransferUser?._id === user._id"
                    [class.border-transparent]="selectedBillingAdminTransferUser?._id !== user._id"
                    (click)="selectedBillingAdminTransferUser = user">
                    <img [src]="user | userAvatar" class="rounded-full w-8 h-8 object-cover" alt="" />
                    <div class="flex flex-col flex-1 min-w-0">
                        <span class="text-sm font-medium truncate">{{ user | fullName }}</span>
                        <span class="text-xs text-gray-500 truncate">{{ user.email }}</span>
                    </div>
                    @if(selectedBillingAdminTransferUser?._id === user._id){
                    <app-icon type="check" source="lucide" class="text-orange-500" />
                    }
                </div>
                } @empty {
                <div class="text-sm text-gray-500 text-center py-4">No users found</div>
                }
            </div>
        </div>
    </ng-template>
    <ng-template #footerTemplate>
        <div class="flex justify-end gap-2">
            <app-button variant="outlined" severity="contrast" label="Cancel"
                (clicked)="cancelBillingAdminTransfer()" />
            <app-button variant="filled" severity="primary" label="Transfer & Continue"
                [disabled]="!selectedBillingAdminTransferUser || isTransferringBillingAdmin"
                (clicked)="confirmBillingAdminTransfer()" />
        </div>
    </ng-template>
</app-dialog>

<!-- Transfer Ownership Dialog -->
<app-transfer-ownership-dialog [(visible)]="transferOwnershipDialogVisible"
    [userCount]="getTransferOwnershipUserCount()" [transferFunction]="getTransferFunction()"
    [isDefaultTransferDisabled]="isDeleteUserTransfer ? isDeleteUserTransferDisabled : false"
    (transferCompleted)="onTransferCompleted($event)" (transferConfirmed)="onTransferOwnershipConfirmed($event)">
</app-transfer-ownership-dialog>


<!-- Bulk Approve User Creation Dialog -->
<app-dialog [(visible)]="bulkApproveCreationDialogVisible" title="Approve User Creation" [showCloseButton]="false"
    class="max-w-[35rem]" [fullscreenOnMobile]="true">
    <ng-template #bodyTemplate>
        <div class="flex gap-2 p-4">
            <div class="mt-1">
                <app-icon [type]="'triangle-alert'" [size]="'sm'" [source]="'lucide'"
                    [class]="'text-yellow-600'"></app-icon>
            </div>
            <div class="flex flex-col justify-start items-start">
                <p class="text-gray-700 mb-2 text-base font-semibold text-start">
                    Are you sure you want to approve creation of user(s) ({{
                    getSelectedApproveCreationRequests().length }})?
                </p>
                <p class="text-gray-600 mb-4 text-sm text-start">
                    Once approved, these users will be created. This action can't be undone, so please review the
                    details before continuing.
                </p>
            </div>
        </div>
    </ng-template>
    <ng-template #footerTemplate>
        <div class="flex gap-2 justify-end">
            <app-button label="Cancel" variant="outlined" severity="contrast"
                (clicked)="bulkApproveCreationDialogVisible = false" />
            <app-button label="Yes, approve" variant="filled" (clicked)="confirmBulkApproveCreation()"
                [enableThrottle]="true" severity="primary" />
        </div>
    </ng-template>
</app-dialog>

<!-- Bulk Reject User Creation Dialog -->
<app-dialog [(visible)]="bulkRejectCreationDialogVisible" title="Reject User Creation" [showCloseButton]="false"
    class="max-w-[35rem]" [fullscreenOnMobile]="true">
    <ng-template #bodyTemplate>
        <div class="flex gap-2 p-4">
            <div class="mt-1">
                <app-icon [type]="'triangle-alert'" [size]="'sm'" [source]="'lucide'"
                    [class]="'text-red-600'"></app-icon>
            </div>
            <div class="flex flex-col justify-start items-start">
                <p class="text-gray-700 mb-2 text-base font-semibold text-start">
                    Are you sure you want to reject creation of user(s) ({{
                    getSelectedRejectCreationRequests().length }})?
                </p>
                <p class="text-gray-600 mb-4 text-sm text-start">
                    Rejecting this will stop these users from being created. This action can't be undone, but your
                    current setup will stay the same.
                </p>
            </div>
        </div>
    </ng-template>
    <ng-template #footerTemplate>
        <div class="flex gap-2 justify-end">
            <app-button label="Cancel" variant="outlined" severity="contrast"
                (clicked)="bulkRejectCreationDialogVisible = false" />
            <app-button label="Yes, reject" variant="filled" (clicked)="confirmBulkRejectCreation()"
                [enableThrottle]="true" severity="danger" />
        </div>
    </ng-template>
</app-dialog>

<!-- Bulk Approve Deactivation Dialog -->
<app-dialog [(visible)]="bulkApproveDeactivationDialogVisible" title="Approve Deactivation" [showCloseButton]="false"
    class="max-w-[35rem]" [fullscreenOnMobile]="true">
    <ng-template #bodyTemplate>
        <div class="flex gap-2 p-4">
            <div class="mt-1">
                <app-icon [type]="'triangle-alert'" [size]="'sm'" [source]="'lucide'"
                    [class]="'text-yellow-600'"></app-icon>
            </div>
            <div class="flex flex-col justify-start items-start">
                <p class="text-gray-700 mb-2 text-base font-semibold text-start">
                    Are you sure you want to approve deactivation of user(s) ({{
                    getSelectedApproveDeactivationRequests().length }})?
                </p>
                <p class="text-gray-600 mb-4 text-sm text-start">
                    Approving this will deactivate the selected users. This action can't be undone, so make sure
                    everything looks right before proceeding.
                </p>
            </div>
        </div>
    </ng-template>
    <ng-template #footerTemplate>
        <div class="flex gap-2 justify-end">
            <app-button label="Cancel" variant="outlined" severity="contrast"
                (clicked)="bulkApproveDeactivationDialogVisible = false" />
            <app-button label="Yes, approve" variant="filled" (clicked)="confirmBulkApproveDeactivation()"
                [enableThrottle]="true" severity="primary" />
        </div>
    </ng-template>
</app-dialog>

<!-- Bulk Reject Deactivation Dialog -->
<app-dialog [(visible)]="bulkRejectDeactivationDialogVisible" title="Reject Deactivation" [showCloseButton]="false"
    class="max-w-[35rem]" [fullscreenOnMobile]="true">
    <ng-template #bodyTemplate>
        <div class="flex gap-2 p-4">
            <div class="mt-1">
                <app-icon [type]="'triangle-alert'" [size]="'sm'" [source]="'lucide'"
                    [class]="'text-red-600'"></app-icon>
            </div>
            <div class="flex flex-col justify-start items-start">
                <p class="text-gray-700 mb-2 text-base font-semibold text-start">
                    Are you sure you want to reject deactivation of user(s) ({{
                    getSelectedRejectDeactivationRequests().length }})?
                </p>
                <p class="text-gray-600 mb-4 text-sm text-start">
                    Rejecting this will keep the selected users active. This action can't be undone, and no changes
                    will be made to the current setup.
                </p>
            </div>
        </div>
    </ng-template>
    <ng-template #footerTemplate>
        <div class="flex gap-2 justify-end">
            <app-button label="Cancel" variant="outlined" severity="contrast"
                (clicked)="bulkRejectDeactivationDialogVisible = false" />
            <app-button label="Yes, reject" variant="filled" (clicked)="confirmBulkRejectDeactivation()"
                [enableThrottle]="true" severity="danger" />
        </div>
    </ng-template>
</app-dialog>

<!-- Bulk Reject Credits Dialog -->
<app-dialog [(visible)]="bulkRejectCreditDialogVisible" title="Reject Credit Requests" [showCloseButton]="false"
    class="max-w-[35rem]" [fullscreenOnMobile]="true">
    <ng-template #bodyTemplate>
        <div class="flex gap-2 p-4">
            <div class="mt-1">
                <app-icon [type]="'triangle-alert'" [size]="'sm'" [source]="'lucide'"
                    [class]="'text-red-600'"></app-icon>
            </div>
            <div class="flex flex-col justify-start items-start">
                <p class="text-gray-700 mb-2 text-base font-semibold text-start">
                    Are you sure you want to reject {{ bulkSelectedRequestIds.length }} credit
                    {{ bulkSelectedRequestIds.length === 1 ? 'request' : 'requests' }}?
                </p>
                <p class="text-gray-600 mb-4 text-sm text-start">
                    Rejecting these will remove the credit requests. This action can't be undone.
                </p>
            </div>
        </div>
    </ng-template>
    <ng-template #footerTemplate>
        <div class="flex gap-2 justify-end">
            <app-button label="Cancel" variant="outlined" severity="contrast"
                (clicked)="bulkRejectCreditDialogVisible = false" />
            <app-button label="Yes, reject" variant="filled" (clicked)="confirmBulkRejectCredit()"
                [enableThrottle]="true" severity="danger" />
        </div>
    </ng-template>
</app-dialog>

<!-- Data Table Templates -->
<!-- Name Template -->
<ng-template #nameTemplateRef let-user="$implicit">
    <span class="text-sm font-medium text-gray-800">
        {{ tab === 'requests' ? (user.requestType === REQUEST_TYPE.PLAN_CHANGE ? (user.metadata?.['userName'] ||
        user.name || '-') : (user.name || '-')) : user.fullName }}
    </span>
</ng-template>

<!-- Contact Template -->
<ng-template #contactTemplateRef let-user="$implicit">
    <span class="text-sm text-gray-800">
        {{ user.phoneNumber ? user.phoneNumber.countryCode + '-' + user.phoneNumber.contactNumber : '-' }}
    </span>
</ng-template>

<!-- Email Template -->
<ng-template #emailTemplateRef let-user="$implicit">
    <div class="flex items-center">
        <div class="flex items-center">
            <span class="text-sm text-gray-800">{{ (tab === 'requests' && user.requestType === REQUEST_TYPE.PLAN_CHANGE)
                ? (user.metadata?.['userEmail'] || user.email) : user.email }}</span>
        </div>
        @if(tab === 'users' && user.registrationStatus == 'PENDING'){
        <div class="ml-2 bg-blue-50 px-2 py-1 rounded-base border-blue-400 border">
            <span class="text-blue-500 text-xs">Pending invite</span>
        </div>
        }
    </div>
</ng-template>

<!-- Role Template -->
<ng-template #roleTemplateRef let-user="$implicit" let-rowIndex="index">
    <div class="flex justify-start">
        @if(tab === 'requests') {
        <div class="p-1">
            <span class="text-sm text-gray-800">{{getRoleLabel(user.role)}}</span>
        </div>
        }@else if(isAdmin && currentUser.email != user.email && user.role !== USER_ROLE.SUPER_ADMIN){
        <app-select [(value)]="user.role" [options]="roleOptions" [config]="{
                placeholder: 'Select Role',
                searchable: false,
                clearable: false,
                disabled: currentUser.email == user.email,
                styleClass: 'border w-32 rounded-base',
                style: {'width': '100%'},
                appendTo: 'body'
            }" (onChange)="tab === 'users' ? updateUserRole(user) : updateInviteUser(user)">
        </app-select>
        }@else {
        <div class="p-1">
            <span class="text-sm text-gray-800">{{getRoleLabel(user.role)}}</span>
        </div>
        }
    </div>
</ng-template>



<!-- Additional Roles Template -->
<ng-template #additionalRolesTemplateRef let-user="$implicit" let-rowIndex="index">
    <div class="flex justify-start">
        @if(isAdmin && currentUser.email != user.email && user.role !== USER_ROLE.SUPER_ADMIN && user.role !==
        USER_ROLE.MEMBER) {
        <app-select [value]="user.additionalRoles?.[0] ?? null" [options]="additionalRoleOptions" [config]="{
                placeholder: 'Assign Role',
                searchable: false,
                clearable: true,
                styleClass: 'border w-36 rounded-base',
                style: {'width': '100%'},
                appendTo: 'body'
            }" (onChange)="updateUserAdditionalRoles(user, $event)">
        </app-select>
        } @else if(user.additionalRoles && user.additionalRoles.length > 0) {
        <div class="p-1">
            <span class="text-sm text-gray-800">{{ getAdditionalRoleLabel(user.additionalRoles[0]) }}</span>
        </div>
        } @else {
        <div class="p-1">
            <span class="text-sm text-gray-500">-</span>
        </div>
        }
    </div>
</ng-template>

<!-- Workspace Template -->
<ng-template #workspaceTemplateRef let-request="$implicit">
    <span class="text-sm text-gray-800">
        {{ request.workspace?.name || '-' }}
    </span>
</ng-template>

<!-- Status Template -->
<ng-template #statusTemplateRef let-request="$implicit">
    <div class="flex flex-col gap-1.5 items-start justify-start">
        @if(request.requestType === REQUEST_TYPE.CREATION){
        <div>
            {{request.requestStatus | titlecase}}
        </div>
        }
        @if(request.requestType === REQUEST_TYPE.DEACTIVATION){
        <div class="text-danger">
            {{request.requestStatus | titlecase}}
        </div>
        }
        @if(request.requestType === REQUEST_TYPE.CREDITS){
        <div class="flex flex-col gap-1">
            <span class="text-xs text-gray-400">Requested credits</span>
            <div class="flex items-center gap-3">
                <div class="flex items-center gap-1">
                    <app-icon type="zap" source="lucide" size="sm" />
                    <span class="text-sm font-semibold text-gray-800">{{ request.metadata?.ask ?? 0 }}</span>
                </div>
                <div class="flex items-center gap-1">
                    <app-icon [type]="CREDITS_SVG.AGENT_MODE" source="svg" size="sm" />
                    <span class="text-sm font-semibold text-gray-800">{{ request.metadata?.agent ?? 0 }}</span>
                </div>
            </div>
        </div>
        }
        @if(request.requestType === REQUEST_TYPE.PLAN_CHANGE){
        <div class="flex flex-col gap-1">
            <span class="text-xs text-gray-400">Requested plan change</span>
            <div class="flex items-center gap-1 text-sm font-semibold">
                @if(request.metadata?.['oldPlanName']) {
                <span class="text-gray-500">{{ request.metadata['oldPlanName'] }}</span>
                <app-icon type="arrow-right" source="lucide" size="sm" class="text-gray-400" />
                }
                <span class="text-blue-700">{{ request.metadata?.['planName'] || 'Plan change' }}</span>
            </div>
            @if(request.metadata?.['userEmail'] || request.metadata?.['userName']) {
            <span class="text-xs text-gray-500">For: <span class="font-medium text-gray-700">{{
                    request.metadata?.['userName'] || request.metadata?.['userEmail'] }}</span>
                @if(request.metadata?.['userName']) {<span class="text-gray-400">({{ request.metadata?.['userEmail']
                    }})</span>}</span>
            }
        </div>
        }
        @if(request.requestType === REQUEST_TYPE.INVITE_PAYMENT){
        <ng-container *ngTemplateOutlet="invitePaymentTemplateRef; context: { $implicit: request }"></ng-container>
        }
    </div>
</ng-template>

<!-- Invite Payment Template -->
<ng-template #invitePaymentTemplateRef let-request="$implicit">
    <div class="flex flex-col gap-1">
        <span class="text-xs text-gray-400">Requested invite payment</span>
        <div class="flex flex-col gap-1">
            <span class="text-xs text-gray-700">{{ request.metadata?.['memberEmails'] }}</span>
        </div>
    </div>
</ng-template>

<!-- Ask Mode Template -->
<ng-template #askModeTemplateRef let-user="$implicit">
    @if(tab === 'users' && user._id !== currentUser._id && user.role !== USER_ROLE.SUPER_ADMIN) {
    <div class="flex justify-center">
        <app-toggle [ngModel]="user.agentModeSettings?.askMode ?? true"
            (onChange)="updateAgentModeSettings(user, 'askMode', $event)" [color]="'#3255FA'">
        </app-toggle>
    </div>
    }
</ng-template>

<!-- Agent Mode Template -->
<ng-template #agentModeTemplateRef let-user="$implicit">
    @if(tab === 'users' && user._id !== currentUser._id && user.role !== USER_ROLE.SUPER_ADMIN) {
    <div class="flex justify-center">
        <app-toggle [ngModel]="user.agentModeSettings?.agentMode ?? true"
            (onChange)="updateAgentModeSettings(user, 'agentMode', $event)" [color]="'#3255FA'">
        </app-toggle>
    </div>
    }
</ng-template>

<!-- Change Plan Template -->
<ng-template #changePlanTemplateRef let-user="$implicit">
    @if(tab === 'users' && hasBillingAccess) {
    <div class="flex items-center gap-1.5">
        <div class="w-[80%] flex flex-col">
            <app-button class="w-full" variant="outlined" severity="contrast"
                [label]="isSalesPaymentMode ? 'Talk to sales' : getUserPlanName(user)" icon="chevron-right"
                iconPosition="right" [iconSource]="'lucide'" (clicked)="openCheckoutForUser(user)"
                [disabled]="isTrail()" [toolTip]="isSalesPaymentMode ? 'Talk to sales' : getUserPlanName(user)"
                [toolTipPosition]="'top'" />
        </div>
        <div
            class="relative inline-flex items-center justify-center w-8 h-8 shrink-0 border border-gray-200 rounded-lg overflow-hidden">
            <app-icon type="building-2" source="lucide" size="sm" class="text-gray-800" />
            @if(hasUserPlanOverride(user)) {
            <div class="absolute inset-0 flex items-center justify-center pointer-events-none">
                <div class="w-5 h-px bg-gray-800 rotate-[-45deg]"></div>
            </div>
            }
        </div>
        @if(getUserPendingDowngrade(user); as pd) {
        <div class="inline-flex items-center justify-center w-8 h-8 shrink-0 border border-gray-200 rounded-lg"
            [pTooltip]="'Downgrade to ' + pd.name + ' on ' + (pd.effectiveAt | date:'mediumDate')"
            tooltipPosition="top">
            <app-icon type="trending-down" source="lucide" size="sm" class="text-gray-800" />
        </div>
        }
    </div>
    }
</ng-template>

@if(showCheckoutDialog) {
<app-checkout-dialog [(visible)]="showCheckoutDialog" [plan]="null" [plans]="availablePlans"
    [selectedEntityType]="userEntityType" [users]="bulkChangePlanUsers" submitLabel="Request change"
    [showAddons]="false" [showUsers]="false" [showTrial]="false" [filterByOrgBillingCycle]="true"
    (onProceed)="proceedToCheckout($event)">
</app-checkout-dialog>
}

<app-phone-number-dialog [(visible)]="showPhoneNumberDialog" (phoneNumberSubmitted)="onPhoneNumberSubmitted()">
</app-phone-number-dialog>

@if(showInviteSingleCheckoutDialog) {
<app-checkout-dialog [(visible)]="showInviteSingleCheckoutDialog" [plan]="orgDefaultPlan" [plans]="availablePlans"
    [selectedEntityType]="userEntityType" [inviteEmails]="currentMemberEmails" submitLabel="Add User"
    [showAddons]="false" [showUsers]="false" [showTrial]="false" [filterByOrgBillingCycle]="true"
    [source]="CheckoutSource.INVITE" (onProceed)="onSingleMemberPlanSelected($event)">
</app-checkout-dialog>
}

@if(showInviteBulkCheckoutDialog) {
<app-checkout-dialog [(visible)]="showInviteBulkCheckoutDialog" [plan]="orgDefaultPlan" [plans]="availablePlans"
    [selectedEntityType]="userEntityType" [inviteEmails]="bulkInviteEmails" [inviteMembers]="bulkInviteMembers"
    submitLabel="Proceed to Payment" [showAddons]="false" [showUsers]="false" [showTrial]="false" [showPlan]="false"
    [filterByOrgBillingCycle]="true" [source]="CheckoutSource.INVITE" (onProceed)="proceedToInviteCheckout($event)">
</app-checkout-dialog>
}

<!-- Actions Template -->
<ng-template #actionsTemplateRef let-user="$implicit">
    <div class="flex justify-start items-start gap-1">
        @if(tab === 'users') {
        @if(user._id !== currentUser._id && user.role !== USER_ROLE.SUPER_ADMIN) {
        <app-icon type="trash-2" source="lucide" class="text-danger cursor-pointer"
            (click)="[USER_ROLE.ADMIN, USER_ROLE.SUPER_ADMIN].includes(currentUser.role) && deleteUser(user._id)"
            pTooltip="Delete User" tooltipPosition="top" />
        }
        }@else if(tab === 'invites') {
        <div class="flex items-center gap-8">
            <app-icon type="trash-2" source="lucide" class="text-danger cursor-pointer" (click)="deleteInvite(user._id)"
                pTooltip="Delete Invite" tooltipPosition="top" />
            @if(user.role !== USER_ROLE.SUPER_ADMIN) {
            <app-button variant="outlined" severity="primary" label="Resend Invite" (clicked)="resendInvite(user)" />
            }
        </div>
        }@else if(tab === 'requests') {
        @if(user.status === 'REQUESTED' && hasBillingAccess) {
        <div class="flex items-center justify-center" (click)="$event.stopPropagation()">
            <app-menu #requestMenu [items]="getRequestMenuItems(user)">
                <div class="px-2 py-1.5 border border-gray-300 rounded-base cursor-pointer"
                    (click)="requestMenu.toggle($event)">
                    <app-icon [type]="'ellipsis'" [size]="'sm'" [source]="'lucide'"
                        [class]="'text-gray-600'"></app-icon>
                </div>
            </app-menu>
        </div>
        } @else if(user.status === 'ACCEPTED') {
        <span
            class="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-700">
            Approved
        </span>
        } @else if(user.status === 'REJECTED') {
        <span
            class="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-700">
            Rejected
        </span>
        }
        }
    </div>
</ng-template>


<ng-template #userTemplateRef let-request="$implicit">
    <div class="flex items-center justify-start text-sm gap-2 text-gray-800">
        @if(request.requestedBy){
        <p-avatar [image]="request.requestedBy | userAvatar" styleClass="header-avatar h-5 w-5" shape="circle"
            size="normal" class="h-5 mr-1" />
        <app-user-name-display [user]="request.requestedBy">
        </app-user-name-display>
        }@else {
        <span>-</span>
        }
    </div>
</ng-template>

<!-- History Action Taken Template -->
<ng-template #historyActionTemplateRef let-request="$implicit">
    <span class="text-sm font-medium" [ngClass]="{
        'text-green-600': getHistoryActionLabel(request) === 'Accepted',
        'text-red-600': getHistoryActionLabel(request) === 'Rejected',
        'text-gray-500': getHistoryActionLabel(request) !== 'Accepted' && getHistoryActionLabel(request) !== 'Rejected'
    }">{{ getHistoryActionLabel(request) }}</span>
</ng-template>

<ng-template #azureRoleTemplateRef let-person="$implicit">
    <app-select [options]="roleOptions" [(ngModel)]="person.role" [config]="roleConfigInline">
    </app-select>
</ng-template>

<ng-template #azureActionsTemplateRef let-person="$implicit">
    <div class="flex items-center gap-2">
        <app-icon type="trash-2" source="lucide" class="cursor-pointer text-red-500 hover:text-red-700"
            (click)="removeAzurePerson(person)" pTooltip="Remove" tooltipPosition="top" />
    </div>
</ng-template>

<!-- Azure Dialog -->
<app-dialog [(visible)]="azureDialogVisible" title="Add people from Azure" (closed)="onAzureDialogHide()"
    class="max-w-[90vw] h-[90vh]" [fullscreenOnMobile]="true">
    <ng-template #bodyTemplate>
        <div class="flex gap-4 h-full p-4">
            <!-- Left Panel - Search and Fetch -->
            <div class="w-1/3 flex flex-col gap-4 border-r pr-4">
                <div class="flex gap-2">
                    <input type="text" pInputText [(ngModel)]="azureSearchValue" placeholder="Search with name"
                        class="flex-1 p-2 border rounded-lg" (input)="onAzureSearchChange()" />
                </div>

                <div class="flex flex-row items-center flex-wrap justify-between">
                    <div class="flex items-center gap-2">
                        <p-checkbox [(ngModel)]="selectAllAzure" (onChange)="toggleSelectAllAzure()" [binary]="true"
                            inputId="selectAll" />
                        <label for="selectAll" class="cursor-pointer">Select all
                            ({{totalAzureUsers}})</label>
                    </div>

                    <app-button variant="filled" severity="primary"
                        [label]="isLoadingAzurePeople ? 'Fetching...' : (azurePeopleList.length > 0 ? 'Refresh' : 'Fetch people')"
                        [icon]="'refresh-cw'" [iconSource]="'lucide'" iconPosition="left"
                        (clicked)="refreshAzurePeople()" [disabled]="isLoadingAzurePeople" />

                </div>


                @if(isLoadingAzurePeople){
                <div class="flex-1 flex flex-col items-center justify-center gap-4">
                    @if(searchAnimationData){
                    <app-lottie-animation [animationData]="searchAnimationData" [loop]="true" [autoplay]="true"
                        width="300px" height="200px">
                    </app-lottie-animation>
                    }
                    <p class="text-gray-600 text-center">Fetching people from Azure...</p>
                </div>
                } @else if(azurePeopleList.length === 0){
                <div class="flex-1 flex flex-col items-center justify-center gap-4">
                    <!-- <i [innerHTML]="BOB_IMAGES.FINGER_UP | sanitizeHtml" [class]="getIconSize() + ' ' + iconClass()"></i> -->
                    <app-icon [type]="BOB_IMAGES.FINGER_UP" [source]="ICON_SOURCE.SVG" [size]="'default'"></app-icon>
                    <p class="text-gray-600 text-center">Click "Fetch people" to add people</p>
                </div>
                }

                @if(azurePeopleList.length > 0 || isLoadingAzurePeople){
                <div class="flex-1 overflow-auto" (scroll)="onAzureListScroll($event)">
                    @if(azurePeopleList.length === 0 && !isLoadingAzurePeople){
                    <div class="flex flex-col items-center justify-center gap-4 py-8">
                        <app-icon type="search" source="lucide" class="text-4xl text-gray-400" />
                        <p class="text-gray-600 text-center">No people found matching "{{azureSearchValue}}"</p>
                    </div>
                    } @else {
                    <div class="flex flex-col gap-2">
                        @for(person of azurePeopleList; track person.id){
                        <div class="flex items-center gap-2 p-2 border rounded-lg hover:bg-gray-50 cursor-pointer"
                            (click)="toggleAzurePersonSelection(person)">
                            <p-checkbox [(ngModel)]="person.selected" [binary]="true" />
                            <div class="flex-1">
                                <div class="font-medium">{{person.name}}</div>
                                <div class="text-sm text-gray-600">{{person.email}}</div>
                            </div>
                        </div>
                        }
                        @if(isLoadingMoreAzureUsers){
                        <div class="flex justify-center py-4">
                            <app-icon type="loader-circle" source="lucide" class="text-2xl text-black animate-spin" />
                        </div>
                        }
                    </div>
                    }
                </div>
                }
            </div>

            <!-- Right Panel - Selected People -->
            <div class="flex-1 flex flex-col gap-4">
                <div class="font-bold text-lg">Selected people</div>

                @if(isLoadingSelectAllAzure){
                <div class="flex-1 flex flex-col items-center justify-center gap-4">
                    @if(searchAnimationData){
                    <app-lottie-animation [animationData]="searchAnimationData" [loop]="true" [autoplay]="true"
                        width="300px" height="200px">
                    </app-lottie-animation>
                    }
                    <p class="text-gray-600 text-center">Loading all users and selecting them...</p>
                </div>
                } @else {
                <div class="flex-1 overflow-auto">
                    <app-data-table [data]="selectedAzurePeople" [columns]="azurePeopleTableColumns"
                        [config]="azurePeopleTableConfig" [dataKey]="'id'" [customTemplates]="templatesMap"
                        tableClass="text-sm">
                    </app-data-table>
                </div>
                }

                <div class="flex justify-end gap-2 pt-4 border-t">
                    <app-button variant="outlined" severity="contrast" label="Cancel"
                        (clicked)="azureDialogVisible = false" />
                    <app-button variant="filled" severity="primary" label="Add Selected People"
                        (clicked)="addSelectedAzurePeople()"
                        [disabled]="selectedAzurePeople.length === 0 || !canAddSelectedAzurePeople()" />
                </div>
                <!-- } -->
            </div>
        </div>
    </ng-template>
</app-dialog>


<!-- Approve Plan Change Dialog -->
<app-dialog [(visible)]="approvePlanChangeDialogVisible"
    [title]="(isLoadingPlans || isFetchingProratedCharge) ? 'Approve Plan Change' : (!isPlanChangeDowngrade() ? 'Plan Change Checkout' : 'Approve Plan Change')"
    [showCloseButton]="false" class="max-w-[35rem]" [fullscreenOnMobile]="true">
    <ng-template #bodyTemplate>
        <div class="flex flex-col gap-4 p-4">
            @if(isLoadingPlans || isFetchingProratedCharge) {
            <div class="flex items-center justify-center p-8">
                <app-icon type="loader-circle" source="lucide" class="text-2xl text-gray-400 animate-spin" />
            </div>
            } @else if(selectedRequest) {
            <!-- Plan summary -->
            <div class="rounded-lg border border-gray-200 p-4 flex flex-col gap-3">
                <div class="flex items-center justify-between">
                    <span class="text-sm text-gray-500">Requested by</span>
                    <span class="text-sm font-medium text-gray-800">{{ selectedRequest.email }}</span>
                </div>
                <div class="flex items-center justify-between">
                    <span class="text-sm text-gray-500">Requested for</span>
                    <div class="flex flex-col items-end">
                        @if(selectedRequest.metadata['userName']) {
                        <span class="text-sm font-medium text-gray-800">{{ selectedRequest.metadata['userName']
                            }}</span>
                        }
                        <span class="text-xs text-gray-500">{{ selectedRequest.metadata['userEmail'] }}</span>
                    </div>
                </div>
                @if(selectedRequest.metadata['oldPlanName']) {
                <div class="flex items-center justify-between">
                    <span class="text-sm text-gray-500">Current plan</span>
                    <span class="text-sm font-medium text-gray-800">{{ selectedRequest.metadata['oldPlanName'] }}</span>
                </div>
                }
                <div class="flex items-center justify-between">
                    <span class="text-sm text-gray-500">Requested plan</span>
                    <span class="text-sm font-semibold text-gray-800">{{ selectedRequest.metadata['planName'] }}</span>
                </div>
                <div class="flex items-center justify-between">
                    <span class="text-sm text-gray-500">Billing</span>
                    <span class="text-sm font-medium text-gray-800">
                        ${{ proratedCharge | number:'1.2-2' }}/{{ (selectedRequest.metadata['pricingTerm']
                        ?? 'MONTH') | lowercase }}
                        @if(selectedRequest.metadata['pricingTerm'] === 'YEAR') {
                        <span class="text-xs text-gray-400 ml-1">(≈ ${{ getRequestedPlanMonthlyPrice() | number:'1.2-2'
                            }}/mo)</span>
                        }
                    </span>
                </div>
            </div>

            @if(!isPlanChangeDowngrade()) {
            <!-- Upgrade checkout summary -->
            <div class="rounded-lg border border-gray-200 divide-y divide-gray-100">
                <div class="flex items-center justify-between px-4 py-3">
                    <span class="text-sm text-gray-500">Current plan (per {{ getOrgActualTerm() }})</span>
                    <span class="text-sm text-gray-800">${{ getOldPlanActualPrice() | number:'1.2-2' }}</span>
                </div>
                <div class="flex items-center justify-between px-4 py-3">
                    <span class="text-sm text-gray-500">New plan (per {{ (selectedRequest.metadata['pricingTerm'] ??
                        'MONTH') | lowercase }})</span>
                    <span class="text-sm text-gray-800">${{ getRequestedPlanActualPrice() | number:'1.2-2' }}</span>
                </div>
                <div class="flex items-center justify-between px-4 py-3 bg-gray-50 rounded-b-lg">
                    <span class="text-sm font-semibold text-gray-800">Amount due today</span>
                    @if(proratedCharge === null) {
                    <app-icon type="loader-circle" source="lucide" class="text-sm text-gray-400 animate-spin" />
                    } @else {
                    <span class="text-base font-bold text-gray-900">${{ proratedCharge | number:'1.2-2' }}</span>
                    }
                </div>
            </div>
            <p class="text-xs text-gray-400 text-center">You will be redirected to a secure checkout page to complete
                payment.</p>
            } @else {
            <!-- Downgrade — no payment -->
            <div
                class="rounded-md bg-green-50 border border-green-200 px-4 py-3 text-sm text-green-800 flex items-center gap-2">
                <app-icon type="check-circle" source="lucide" size="sm" class="shrink-0" />
                <span>No payment required — downgrade will come in affect from next billing cycle</span>
            </div>
            }
            }
        </div>
    </ng-template>
    <ng-template #footerTemplate>
        <div class="flex gap-2 justify-end">
            <app-button label="Cancel" variant="outlined" severity="contrast"
                (clicked)="approvePlanChangeDialogVisible = false" />
            <app-button
                [label]="isApprovingPlanChange ? 'Approving...' : (isLoadingPlans || isFetchingProratedCharge) ? 'Loading...' : (!isPlanChangeDowngrade() ? (proratedCharge === null ? 'Loading...' : 'Pay $' + (proratedCharge | number:'1.2-2') + ' & Approve') : 'Approve')"
                variant="filled" severity="primary" (clicked)="confirmApprovePlanChangeRequest()"
                [enableThrottle]="true"
                [disabled]="isApprovingPlanChange || isLoadingPlans || isFetchingProratedCharge || (!isPlanChangeDowngrade() && proratedCharge === null)" />
        </div>
    </ng-template>
</app-dialog>

<!-- Credits Checkout Dialog -->
<app-credits-checkout-dialog [(visible)]="checkoutDialogVisible" [checkoutItems]="checkoutItems"
    [successUrl]="checkoutSuccessUrl" [cancelUrl]="checkoutCancelUrl" (allocated)="getAccessRequests()" />

<!-- Max Users Reached Dialog -->
<app-dialog [(visible)]="maxUsersReachedDialogVisible" title="Organization Limit Reached" [showCloseButton]="false"
    class="max-w-[35rem]" [fullscreenOnMobile]="true">
    <ng-template #bodyTemplate>
        <div class="flex gap-2 p-4">
            <div class="mt-1">
                <app-icon [type]="'triangle-alert'" [size]="'sm'" [source]="'lucide'"
                    [class]="'text-orange-600'"></app-icon>
            </div>
            <div class="flex flex-col justify-start items-start">
                <p class="text-gray-700 mb-2 text-base font-semibold text-start">
                    Organization Limit Reached
                </p>
                <p class="text-gray-600 mb-4 text-sm text-start">
                    The maximum number of users ({{ maxUsersAllowed != null && maxUsersAllowed > 0 ? maxUsersAllowed
                    : 'Unlimited' }}) for your organization has been reached.
                    Please contact your organization administrator.
                </p>
            </div>
        </div>
    </ng-template>
    <ng-template #footerTemplate>
        <div class="flex justify-end">
            <app-button variant="outlined" severity="contrast" label="Close" icon="x" [iconSource]="'lucide'"
                (clicked)="maxUsersReachedDialogVisible = false" />
        </div>
    </ng-template>
</app-dialog>